export default __webpack_public_path__ + "static/media/move_right_sales.8497d5d4.svg";